export default __webpack_public_path__ + "static/media/kid-3.b9a6695e.JPG";